import React from 'react';
import { Text, View, Pressable, StyleSheet, Platform } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../../constants/styles';

import { OPComponent, DateUtils } from '../../../components';

import { currentDeploymentInfoForPatient } from '../../../airforce/helpers';

export const GROUP_WIDTH = __WEB__ ? 175 : 150;
export const RANK_WIDTH = __WEB__ ? 150 : 100;
export const DEPLOY_WIDTH = __WEB__ ? 265 : 120;
export const PATIENT_TYPE_WIDTH = __WEB__ ? 170 : 120;
export const PROCEDURES_WIDTH = __WEB__ ? 200 : 140;
export const NAME_WIDTH = 200;
export const GROUP_STYLE = {
  width: GROUP_WIDTH,
  flexGrow: 0.1,
};
export const RANK_STYLE = {
  width: RANK_WIDTH,
  flexGrow: 0.1,
};
export const DEPLOY_STYLE = __WEB__
  ? {
      width: DEPLOY_WIDTH,
      flexGrow: 0.2,
    }
  : {
      width: DEPLOY_WIDTH,
    };
export const PATIENT_TYPE_STYLE = {
  width: PATIENT_TYPE_WIDTH,
  flexGrow: 0.1,
};
export const PROCEDURES_STYLE = __WEB__
  ? {
      width: PROCEDURES_WIDTH,
      flexGrow: 0.1,
    }
  : {
      width: PROCEDURES_WIDTH,
    };
export const NAME_STYLE = __WEB__
  ? {
      width: NAME_WIDTH,
      flexGrow: 0.4,
    }
  : {
      flex: 1,
    };

function Consult(props) {
  if (!props.consult) return null;
  function handlePress() {
    props.onConsultOpen?.(props.consult);
  }
  return (
    <Pressable style={{ paddingBottom: 7 }} onPress={handlePress}>
      <Text style={styles.linkStyle}>
        {DateUtils.formatDateStringNumeric(props.consult.created_at)}
      </Text>
    </Pressable>
  );
}

export default class ListRow extends OPComponent {
  constructor(props) {
    super(props);
  }

  handleGroupTap = () => {
    const group = this.props.data?.group;
    this.props.handleGroupTap(group);
  };

  handleResidentTap = () => {
    const { data, handleResidentTap } = this.props;
    handleResidentTap(data.caseId);
  };

  handleTaskingIdTap = () => {
    const taskingId = this.props.data?.patient?.extraData?.deployment?.taskingId;
    this.props.handleTaskingIdTap(taskingId);
  };

  _handleResendInvitePress = () => {
    this.props.onResendInvitePress(this.props.data);
  };

  renderConsult = (consult) => {
    return (
      <Consult
        consult={consult}
        onConsultOpen={this.props.onConsultOpen}
        key={consult.consult_request_id}
      />
    );
  };
  renderProcedures() {
    const consults = (this.props.data?.consults || [])
      // .concat(this.props.data?.consults || [])
      .map((c) => {
        return {
          ...c,
          full_name: this.props.data?.name,
          role: this.props.data?.patient.role,
          consult_with: c.medical_service,
        };
      });
    return consults.map(this.renderConsult);
  }

  render() {
    const { data, index } = this.props;

    const group = data?.group || '';
    const rank = data?.patient?.rank || '';
    const deployment = currentDeploymentInfoForPatient(data.patient);
    const deploymentDate = deployment.date;
    const taskingId = deployment.taskingId;
    const odd = index % 2 !== 0;

    const ready = !!deployment?.ready?.clearanceGranted;
    const readyBG = ready ? COLOR.success : COLOR.emphasis;
    const subLabel = `${rank}${rank && group ? ' | ' : ''}${group}`;

    if (!__WEB__)
      return (
        <View style={[styles.container, !odd ? styles.alt : null]}>
          <View style={[THEME.basicRow, { alignItems: 'flex-start' }]}>
            <View style={styles.nameContainer}>
              <Pressable style={styles.nameButton} onPress={this.handleResidentTap}>
                <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
                  {data.name}
                </Text>
              </Pressable>
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                style={[THEME.rowText, { marginTop: 5 }]}
              >
                {subLabel}
              </Text>
            </View>
            <View style={styles.proceduresContainer}>{this.renderProcedures()}</View>
            <View style={styles.deployContainer}>
              {!!deploymentDate && (
                <View style={[THEME.basicRow, { alignItems: 'center' }]}>
                  <View>
                    {!!taskingId && (
                      <Pressable style={styles.taskingIdBtn} onPress={this.handleTaskingIdTap}>
                        <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
                          {taskingId}
                        </Text>
                      </Pressable>
                    )}
                    <Text style={styles.deployText}>
                      {DateUtils.formatDateStringNumeric(new Date(deploymentDate))}
                    </Text>
                  </View>
                  <View style={[styles.deployDot, { backgroundColor: readyBG }]} />
                </View>
              )}
            </View>
          </View>
        </View>
      );

    return (
      <View style={[styles.container, !odd ? styles.alt : null]}>
        <View style={[THEME.basicRow, { alignItems: 'flex-start' }]}>
          <View style={styles.nameContainer}>
            <Pressable style={styles.nameButton} onPress={this.handleResidentTap}>
              <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
                {data.name}
              </Text>
            </Pressable>
          </View>
          <View style={styles.patientTypeContainer}>
            <Text style={THEME.rowText}>{data?.patient?.role}</Text>
          </View>
          {!!__WEB__ && (
            <View style={styles.rankContainer}>
              <Text style={THEME.rowText}>{rank}</Text>
            </View>
          )}
          <Pressable style={styles.groupButton} onPress={this.handleGroupTap}>
            <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
              {group}
            </Text>
          </Pressable>

          <View style={styles.proceduresContainer}>{this.renderProcedures()}</View>
          <View style={styles.deployContainer}>
            {!!deploymentDate && (
              <View style={[THEME.basicRow, { alignSelf: 'stretch' }]}>
                <Pressable style={styles.taskingIdBtn} onPress={this.handleTaskingIdTap}>
                  <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
                    {taskingId}
                  </Text>
                </Pressable>
                {!!taskingId && !!deploymentDate && <Text style={[THEME.rowText]}>{'  |  '}</Text>}
                <Text style={styles.deployText}>
                  {DateUtils.formatDateStringNumeric(new Date(deploymentDate))}
                </Text>
                <View style={{ flex: 1, alignItems: 'flex-start', marginLeft: 15 }}>
                  <View style={[styles.deployDot, { backgroundColor: readyBG }]} />
                </View>
              </View>
            )}
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 15,
  },
  alt: {
    backgroundColor: COLOR.altContrast,
  },
  patientTypeContainer: {
    paddingLeft: 15,
  },
  groupButton: {
    paddingLeft: 15,
    ...GROUP_STYLE,
  },
  nameContainer: {
    ...NAME_STYLE,
    paddingLeft: 15,
  },
  nameButton: {
    flex: 1,
    flexDirection: 'row',
  },
  linkStyle: {
    ...THEME.rowText,
    ...THEME.linkStyle,
    ...FONT.medium,
    textDecorationLine: 'underline',
  },
  patientTypeContainer: {
    ...PATIENT_TYPE_STYLE,
    paddingLeft: 15,
  },
  rankContainer: {
    paddingLeft: 15,
    ...RANK_STYLE,
  },
  proceduresContainer: {
    paddingLeft: 15,
    ...PROCEDURES_STYLE,
  },
  deployContainer: {
    ...DEPLOY_STYLE,
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingLeft: 15,
    paddingRight: 20,
  },
  deployText: {
    ...THEME.rowText,
    marginRight: 10,
    marginTop: __WEB__ ? 0 : 3,
  },
  deployDot: {
    width: 16,
    height: 16,
    borderRadius: 8,
  },
});
